import { logD } from "@blacknut/logging/dist";
import { LOGGING_TAG } from "../utils/logging";
import eventEmitter from "./EventEmitter";
import { EVENT_EMITTER_EVENT_STOP } from "../utils/PlayerUtils";

export const stop = () => {
  logD(LOGGING_TAG, "Emitting stop", eventEmitter.listeners('stop'));
  eventEmitter.emit(EVENT_EMITTER_EVENT_STOP);
};
